export const dateFormat = (
    date: string | Date | null | undefined
): string => {
    if (!date) return "";

    const d = new Date(date);

    // ❌ Invalid date check
    if (isNaN(d.getTime())) return "";

    // ❌ Avoid default backend dates like 0001-01-01 or 1970-01-01
    if (d.getFullYear() <= 1970) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
};